require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-china-yargentina-inversiones-energia-y-sustentabilidad.json") })
        }
      }, "path---es-mx-update-china-yargentina-inversiones-energia-y-sustentabilidad");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-china-yargentina-inversiones-energia-y-sustentabilidad!./.cache/json/es-mx-update-china-yargentina-inversiones-energia-y-sustentabilidad.json
// module id = 920
// module chunks = 231608221292675